<p-panel>
  <div class="d-flex flex-column gap-5">
    <div class="flex-1 w-full">
      <app-reactive-form-builder #formbuilder (stableValueChanges)="stableValueChanges($event)" (goBack)="goBack()"
        (afterSend)="undefined" [form]="form.formFields" [serverUrl]="''" [dropdownLoadTrigger]="dropdownLoadTrigger"
        [previousData]="getModel()"
        [request]="this.getType() === 1 ? this.productosApi.productos.PUT : this.productosApi.productos.POST"
        [getRequest]="this.productosApi.productos.GET">
      </app-reactive-form-builder>
    </div>
    <div *ngIf="getType() === formTypes.CREATION">
      <app-common-list-table [showExportCsv]="false" [request]="vademecumTableRequest" [hideSearch]="true"
        (rowClick)="productSelected($event);" [cols]="form.cols" [small]="true"
        [globalConditionalStyle]="globalConditionalStyle" [globalVisualTransform]="globalVisualTransform"
        [searchValue]="searchValue">

        <ng-template #thEnd>
          <th>
            <p class="d-flex justify-content-center" style="margin-bottom: 0">Ficha Técnica</p>
          </th>
        </ng-template>

        <ng-template #tdEnd let-data>
          <td class="text-center">
            <a *ngIf="data.data"
              [href]="'https://fichas-oficiales.s3.eu-west-3.amazonaws.com/' + data.data.referencia.trim() + '.pdf'"
              target="_blank"
              class="position-relative text-white fw-bold btn btn-primary d-inline-flex gap-2 align-items-center justify-content-center">
              <span>Ficha</span>
              <i class="fa fa-file-pdf-o" aria-hidden="true"></i>
              <i class="fa fa-exclamation-circle text-red position-absolute"
                style="top: -5px; right: -5px; color: red;"></i>
            </a>
          </td>
        </ng-template>

      </app-common-list-table>
    </div>
  </div>

</p-panel>

<p-dialog [(visible)]="form.openDialog" [modal]="true" [style]="{ width: '70vw' }" [closable]="true"
  [dismissableMask]="true" [baseZIndex]="10000" [breakpoints]="{'960px': '75vw', '640px': '90vw'}"
  header="Información Producto {{ productoSeleccionado?.nombre }}">

  <table class="table table-striped table-bordered w-100">
    <thead>
      <tr style="font-size: 0.85rem; text-align: center;">
        <th>Producto</th>
        <th>Fecha de Caducidad</th>
        <th>Materia Activa</th>
        <th>Condiciones de uso</th>
      </tr>
    </thead>
    <tbody style="font-size: 0.75rem;">
      <tr>
        <td style="width: 20vw; text-align: center;">{{ productoSeleccionado?.nombre }}</td>
        <td style="width: 10vw; text-align: center;">{{ fecha_caducidad }}</td>
        <td style="width: 20vw; text-align: center;">{{ productoSeleccionado?.materia_activa }}</td>
        <td style="width: 40vw; text-align: center;">{{ productoSeleccionado?.condiciones_uso }}</td>
      </tr>
    </tbody>
  </table>

  <ng-template pTemplate="footer">
    <div class="text-center w-100">
      <p-button label="Cerrar" (click)="form.openDialog = false"></p-button>
    </div>
  </ng-template>

</p-dialog>